import { FaGithub, FaLinkedin, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { profile } from '../../data/profile';
import { contact } from '../../data/contact';

const SOCIAL_ICONS = {
  GitHub: FaGithub,
  LinkedIn: FaLinkedin,
  Email: FaEnvelope,
  WhatsApp: FaWhatsapp,
};

const Footer = () => {
  return (
    <footer className="bg-black py-8 text-white">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 px-6 sm:flex-row">
        <span className="font-black tracking-tight">{profile.name}</span>

        <div className="flex items-center gap-4">
          {contact
            .filter((c) => SOCIAL_ICONS[c.label] && c.link)
            .map((c) => {
              const Icon = SOCIAL_ICONS[c.label];
              return (
                <a
                  key={c.label}
                  href={c.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={c.label}
                  className="text-white/70 transition-colors hover:text-white"
                >
                  <Icon size={16} />
                </a>
              );
            })}
        </div>

        <span className="text-sm text-white/50">
          © {new Date().getFullYear()} {profile.name}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
